import React from 'react';

const ML_Regressions = () => {
    return (
        <div>ML_Regressions Component</div>
    );
}

export default ML_Regressions;
